function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.759766,
  width: 45,
  height: 47.9508,
  fill: "url(#pattern0)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0_472_11402",
  transform: "scale(0.0163934 0.0153846)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0_472_11402",
  width: 61,
  height: 65,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABBCAYAAABigqxTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABBNJREFUeNrsWjtoFEEYHo8UQQJeESGFmCssIkg8sbHJw0ZthGhhYw60MDYRTZEqggmYysKIaYxFhGxlYXw0auPlUotnEIyQ4hIsAgZyQtAUQpzv3Ilzf2Yzs6+729v9YAiX2Z2d7/+//zF7x9h/bPKxI415Zo4suRfjmjQ/r5i/E/B6urHLJyUtlCYPTrsgrbo2o5l/aJMLaj3jPaZYfTFbj4fWm3TW9nhN0cLqD8T2Kz7yPtfR3f+okUgLmZ/io+xjjbNRkbecpGbjJG+BAXu89Hj/uGYe6xbrTbpEypCQedHjevc0830iBOop70sOtTR0mdeTNDw6ofh/Px+3m7lOjzvIeSCEZ5UbKZFB5p88tpZuSlaxkUiXbJn77czyUZG3wFQAHVkgMd2vOapt2tcEKXM/HZnuaDkehKfTAZMG4eshOriv0eQtd03Pmv1oqcKIndxqQjrvQY55KQOXyJxcfxdcZNqyHd9u1jPBAkuQIEGCBBHGgdYPV7P2W4d0DPii9E3glIWvOzIxcnQ2FTPCQCYVx5hOSCekE9IJ6cjD6G3o8pkp1tnarpxb3d5gS1ur7M3GRza3XohMR7aju+h3v2W0GMifK06yn39+xUfe3W2d7H12jB1qORivmAbxW0cuRD+mKUZXrIqUAXj1adfNKu8OdvSy+6UXyns7Ww9X8gNywer2j+iQBuFC+WuVEWa6hiRie5PeMPc+hjwH4qMrcyzHjSQbbWh5pmKQi+2nK/cIIFdc+bL32x/cP9jRs/t5ke/NyeieSe/N4Pt7bIYrISdtSjbO8xMjyv9jzaWtNdabPl41h8+ywYGxzOUqYy6S+VBiGh5xwl2+IRVhU2NSgggd+myqrLn1xeDljQcLD/Twv9QbYqOIX3iBQsyf5ElPl+ktTkBeHwZESIiymCNGQL+gU54n0jrPTdrxRBWAjaKO0yS4n1LQ8FD5ojogZmFUeq9JgxR4yZr+/nbXk1QB2JAgLIyAJKiDRYgIiVPjIzHC0zUjDQLIujIJKl3VhkzKFo1ReB0epvFtGbbBnuSNTaxJm/1s9946qDKvSfcGw2B9Wcq0NzBJYL5Iw6IFTVkQpUOWOGruYy5/uTd/cCxnHDYyaZWKTJudUH9z8ppvRM7e2Og3fmJDbIO4KvM7AUZGzDqd9tyc8EI9Ty8pZA/i8DiMYUpY9rbT8dYkvGr2EuHG8pOqjO0HTt60XJ7jjUjT83HZxXlZ1GanJDNNYny/9XGdah3TBObqJUJQQDPR3Xa00okh46O3dnvSon08Yv08N2ropyw/BxNRfrwA+YA2JJZLL9ckpoME7bP/yb3Q3KSHyRsZry8iI0NavHGpToLvPK1V00TWKEi+4UhIJ6Sbj3QpZpxL6Mjw49NY/brorwADAChUxPe5GTvbAAAAAElFTkSuQmCC"
}));

function SvgLinepay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinepay);
export default __webpack_public_path__ + "static/media/linepay.66b37b81.svg";
export { ForwardRef as ReactComponent };